WiseMetering.Views.IndexAlarm = Backbone.Marionette.ItemView.extend({
    template: 'templates/ui/layout/empty',

    onShow: function () {
        let columns;
        columns = {
            active: {
                mRender: active => JST['templates/ui/components/circle']({
                    color: WiseMetering.Colors[active ? 'green' : 'red'],
                    title: i18next.t(`glossary.${active ? 'active' : 'disabled'}`)
                }),
                sWidth: '20px'
            },
            name: i18next.t('glossary.title'),
            type: i18next.t('common.type'),
            indicator: i18next.t('glossary.indicator'),
            notifications: i18next.t('glossary.notifications')
        };

        if (WiseMetering.currentUser.isSuperUser()) {
            columns.last_checked_humanized = i18next.t('ui.table.last_checked');
        }

        this.table = new WiseMetering.Views.Table({
            aLengthMenu: [25, 50, 100],
            collection: WiseMetering.alarms,
            columns: columns,
            id: 'alarms',
            modelSerializer: function (model) {
                return {
                    ...model.toJSON(),
                    indicator: model.indicator() ? model.indicator().get('name') : null,
                    last_checked_humanized: model.last_checked_humanized(),
                    notifications: model.notifications().sort().join(', ')
                };
            },
            toolbar_actions: {
                show: {
                    label: i18next.t('ui.actions.show').capitalize(),
                    view_call: model => {
                        const href = `alarms/${model.id}/show`;
                        NavigationService.navigateTo(href, { trigger: true });
                    }
                },
                open_indicator: {
                    icon: 'indicators',
                    label: i18next.t('glossary.indicator').capitalize(),
                    view_call: model => {
                        const href = WiseMetering.indicators.get(model.get('indicator_id')).nodeUrl();
                        Backbone.history.navigate(href, { trigger: true });
                    }
                },
                bulk_create: {
                    label: i18next.t('alarms.bulk_create'),
                    icon: 'bulkCreate',
                    view_call: () => {
                        const href = 'alarms/bulk_create';
                        NavigationService.navigateTo(href, { trigger: true });
                    }
                },
                bulk_delete: {
                    label: i18next.t('alarms.bulk_delete'),
                    icon: 'bulkDelete',
                    permission: 'superuser',
                    view_call: () => {
                        const href = 'alarms/bulk_delete';
                        NavigationService.navigateTo(href, { trigger: true });
                    }
                },
                bulk_edit: {
                    label: i18next.t('alarms.bulk_edit'),
                    icon: 'bulkEdit',
                    view_call: () => {
                        const href = 'alarms/bulk_edit';
                        NavigationService.navigateTo(href, { trigger: true });
                    }
                },
                edit: {
                    view_call: model => {
                        const href = `alarms/${model.id}/edit`;
                        NavigationService.navigateTo(href, { trigger: true });
                    }
                },
                delete: {
                    view_call: model => new WiseMetering.Views.Modal.Destroy({
                        model,
                        title: () => i18next.t('modal.title.alarms.destroy')
                    })
                }
            }
        });

        $(this.el).html(this.table.el);
    },

    onClose: function () {
        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    }
});
